module.exports = __webpack_public_path__ + "img/mgh-fukuoka-nakasu-sp@2x.549622e6.jpg";